module.exports = __webpack_public_path__ + "static/media/10sec_backward.1d6fb813.svg";